<template>
  <div
       class="details-content bidding-detail">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title"
              @click="toBiddingActivities">活动竞价/</span>竞价详情
      </template>
      <template v-slot:content>
        <el-button 
            v-if="operationList.indexOf(operationsBtns.roleSaleActivityManage)!==-1"
            :disabled="biddingDetail.status !== 3?true:false"
            :class="biddingDetail.status !== 3?'btn-black':'btn-blue'"
            @click="confirm"
        >确认发布</el-button>
        <section class="content base-info"
                 ref="baseInfo">
          <div class="content-title">基础信息</div>
          <div class="content-baseInfo">
            <ul class="content-info">
              <li class="item"><span class="desc">活动名称：</span>{{biddingDetail.activityName}}</li>
              <li class="item"><span class="desc">指定仓库：</span>{{biddingDetail.warehouse}}</li>
              <li class="item"><span class="desc">展位数量：</span>{{biddingDetail.boothNum}}</li>
              <li class="item"><span class="desc">起拍价格：</span>￥{{biddingDetail.basePrice}}</li>
              <li class="item"><span class="desc">竞价时间：</span>{{biddingDetail.biddingBeginTime}} - {{biddingDetail.biddingEndTime}}</li>
              <li class="item"><span class="desc">活动时间：</span>{{biddingDetail.beginTime}} - {{biddingDetail.endTime}}</li>
            </ul>
            <div class="content-status">
              <span>当前状态：</span>
              <span>{{biddingDetail.statusValue}}</span>
            </div>
          </div>
        </section>
        <section class="content customer-info">
          <div class="content-title">竞价商品</div>
          <div class="out-container">
            <div class="table">
              <el-table class="table-container"
                        :data="biddingDetailsList">
                <el-table-column label="商品名称"
                                 prop="goodsName"></el-table-column>
                <el-table-column label="供应商名称"
                                 prop="supplierName"></el-table-column>
                <el-table-column label="竞价金额"
                                 prop="biddingPrice"></el-table-column>
                <el-table-column
                  label="当前名次"
                  type="index"
                  width="120"
                  :index='index => (index+1) + (currentPage-1)*pageSize'
                >
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      v-if="operationList.indexOf(operationsBtns.roleSaleActivityManage)!==-1&&scope.row.status == 1"
                      class="btn-text"
                      type="text"
                      @click="toReview(scope.row.id, 2)"
                    >审核</el-button>
                    <el-button
                      v-else
                      class="btn-text"
                      type="text"
                      @click="toReview(scope.row.id, 1)"
                    >查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-tpl-container">
              <pagination-tpl
                :total="total"
                :currentPage="currentPage"
                @queryChange="searchBiddingDetails">
              </pagination-tpl>
            </div>
          </div>
        </section>
        <div class="operations" ref="operations">
          <el-button class="btn-white" @click="toBiddingActivities">返回</el-button>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import { getActivityInfo, getDBOperationPermission } from 'common/js/storage';
import { formaTimeToSecond } from 'common/js/util.js';
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import PaginationTpl from 'base/PaginationTpl';
import DBBiddingActivities from "models/db/biddingActivities.js";
const dbBiddingActivities = new DBBiddingActivities();
export default {
  data() {
    return { 
      // 页面按钮权限--新增、删除
      operationsBtns: {
        roleSaleActivityManage: "ROLE_SALE_activity_manage"
      },
      // 竞价详情相关信息
      biddingDetail: {},
      // 竞价商品总条数
      total: 0,
      currentPage: 1,
      pageSize: 20,
      // 竞价商品列表
      biddingDetailsList: [],
      biddingStatusList: [
        { label: '待竞价', value: 1},
        { label: '竞价中', value: 2},
        { label: '待发布', value: 3},
        { label: '已发布', value: 4},
        { label: '活动中', value: 5},
        { label: '已结束', value: 6},
      ],
    };
  },
  methods: {
    // 翻页
    searchBiddingDetails(query) {
      this.currentPage = query.currentPage
      this._getBiddingDetailsList();
    },
    toBiddingActivities() {
      this.$router.push({
        path: '/admin/marketing/bidding-activities/biddingActivities'
      });
    },
    _getBiddingDetailsList() {
      let id = this.$route.query.id
      let currentPage = this.currentPage
      let isPass = ''
      dbBiddingActivities.getDBActivityDetail(id, currentPage, isPass).then(res => {
        if (res.success) {
          this.total = res.result.totalNum;
          this.pageSize = res.result.pageSize
          let arr = []
          res.result.items.map((i,index) => {
            let obj = {}
            obj.id = i.id
            obj.goodsName = i.goodsName
            obj.supplierName = i.supplierName
            obj.biddingPrice = i.biddingPrice
            obj.status = i.status
            arr.push(obj)
          })
          this.biddingDetailsList = arr
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }
      });
    },
    confirm() {
      this.$router.push({
        path: '/admin/marketing/bidding-activities/shortlist',
        query: {
          id: this.biddingDetail.id
        }
      });
    },
    toReview(id, isReview) {
      this.$router.push({
        path: '/admin/marketing/bidding-activities/review',
        query: {
          id: id,
          isReview: isReview
        }
      });
    },
    //获取基础信息
    getDBBiddingDetailBaseInfo() {
      let id = this.$route.query.id
      dbBiddingActivities.getDBBiddingDetailBaseInfo(id).then(res => {
        if (res.success) {
          let obj = {}
          obj.id = res.result.id;
          obj.activityName = res.result.activityName;
          obj.beginTime = formaTimeToSecond(res.result.beginTime);
          obj.endTime = formaTimeToSecond(res.result.endTime);
          obj.biddingBeginTime = formaTimeToSecond(res.result.biddingBeginTime);
          obj.biddingEndTime = formaTimeToSecond(res.result.biddingEndTime);
          obj.status = res.result.status;
          obj.boothNum = res.result.boothNum;
          obj.basePrice = res.result.basePrice;
          this.biddingStatusList.map(i => {
            if (i.value == res.result.status) {
              obj.statusValue = i.label
            }
          })
          let str = ''
          res.result.warehouse.map(i => {
            str += `,${i}`
          })
          obj.warehouse = str.substring(1)
          this.biddingDetail = obj
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }
      })
    }
  },
  created() {
    this.operationList = getDBOperationPermission();
    this._getBiddingDetailsList()
    this.getDBBiddingDetailBaseInfo()
  },
  mounted() {
    const paddingWidth = 46;
    this.$refs.operations.style.width =
      this.$refs.baseInfo.clientWidth + paddingWidth + 'px';
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.baseInfo.clientWidth + paddingWidth + 'px';
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  }
};
</script>

<style lang="scss">
.bidding-detail {
  .btn-black {
    background: #EEEEEE;
    color: #999999;
  }
  .link-content-inner-container > .content {
    margin-top: 0px;
  }
}
</style>